var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.04761C17 13.4659 13.4183 17.0476 9 17.0476C4.58172 17.0476 1 13.4659 1 9.04761C1 4.62933 4.58172 1.04761 9 1.04761C13.4183 1.04761 17 4.62933 17 9.04761Z",
    fill: "white",
    stroke: "#35C7FF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9C14 11.7614 11.7614 14 9 14C6.23858 14 4 11.7614 4 9C4 6.23858 6.23858 4 9 4C11.7614 4 14 6.23858 14 9Z",
    fill: "#35C7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderThumb);
export default __webpack_public_path__ + "static/media/slider-thumb.8b2d0a17b6689cd5cefead6724541734.svg";
export { ForwardRef as ReactComponent };